var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Loader } from '../loader';
import { loaderStyle, loaderWrapperStyle } from './styles';
function ButtonLoader(_a) {
    var size = _a.size, variant = _a.variant, inverted = _a.inverted, isIconOnly = _a.isIconOnly;
    return (_jsxs("span", __assign({ css: loaderWrapperStyle({ size: size, hasLoadingLabel: !isIconOnly }) }, { children: [_jsx(Loader, { css: loaderStyle({ variant: variant, inverted: inverted }), "aria-label": "Loading", width: size === 'small' ? '12' : '16' }), !isIconOnly && _jsx("span", __assign({ "aria-hidden": "true" }, { children: "Loading\u2026" }))] })));
}
export default ButtonLoader;
